import { Box, Flex, Text, Image, IconButton } from "@chakra-ui/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useState,useEffect } from "react";

// import screen1 from "../../assets/fantacy-1.png";
import screen2 from "../../assets/fantacy-2.png";
import screen3 from "../../assets/fantacy-3.png";

const screens = [screen3, screen2];

export default function FantacyShowcase() {
   const [index, setIndex] = useState(0);
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  
    const prev = () => {
      setIndex((i) => (i === 0 ? screens.length - 1 : i - 1));
    };
  
    const next = () => {
      setIndex((i) => (i === screens.length - 1 ? 0 : i + 1));
    };
  
    const current = screens[index];
    const nextImage = screens[(index + 1) % screens.length];

  return (
    <Box
      minH="100vh"
      bg="radial-gradient(circle at top, #2a124f 0%, #0b0515 60%, #000 100%)"
      color="white"
      py={6}
      px={6}
    >
      {/* Title */}
      <Flex direction="column" align="center" textAlign="center" mb={{ base: 8, md: 12 }}>
        <Text fontSize={{ base: "70px", md: "126px" }} fontWeight="bold" bgGradient={"linear(to-r, #fff , #BDA8FB)" } bgClip={"text"}>
          Fantasy
        </Text>
        <Text maxW="700px" fontSize={{ base: "16", md: "21" }} opacity={0.8} mt={4} color={"#A78BFA"}>
        India’s Ultimate Cricket Arena! Don’t just watch the game—own it. Build your dream XI, outsmart millions of fans, and turn your cricket knowledge into massive rewards. From the IPL to World Cups, every ball matters. Join Winnsta’s Fantasy Cricket today and claim your spot at the top of the leaderboard!
        </Text>
      </Flex>

      {/* Showcase */}
     <Box
        maxW="1400px"
        mx="auto"
        bg="linear-gradient(180deg, rgba(140,94,255,0.18), rgba(140,94,255,0.05))"
        borderRadius="2xl"
        p={{ base: 4, md: 8 }}
        boxShadow="0 0 80px rgba(140, 94, 255, 0.25)"
      >
        <Flex align="center" justify="center" gap={6}>
          {/* Left Arrow */}
          <IconButton
            aria-label="Previous"
            icon={<FaChevronLeft />}
            onClick={prev}
            variant="ghost"
            color="purple.300"
            fontSize={{ base: "20px", md: "28px" }}
            _hover={{ bg: "whiteAlpha.200" }}
          />

          {/* Images */}
          <Flex align="center" justify="center" gap={6}>
            {/* First Image (Always Visible) */}
            <Image
              src={current}
              maxW={{ base: "260px", md: "500px" }}
              borderRadius="xl"
              boxShadow="0 20px 60px rgba(0,0,0,0.6)"
            />

            {/* Second Image (Only Laptop/Desktop) */}
            <Image
              src={nextImage}
              display={{ base: "none", md: "block" }}
             maxW={{ base: "260px", md: "500px" }}
              borderRadius="xl"
              boxShadow="0 20px 60px rgba(0,0,0,0.6)"
            />
          </Flex>

          {/* Right Arrow */}
          <IconButton
            aria-label="Next"
            icon={<FaChevronRight />}
            onClick={next}
            variant="ghost"
            color="purple.300"
            fontSize={{ base: "20px", md: "28px" }}
            _hover={{ bg: "whiteAlpha.200" }}
          />
        </Flex>
      </Box>
    </Box>
  );
}
